import React, { useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import CookieIcon from '@mui/icons-material/Cookie';
import { useNavigate } from 'react-router-dom';
import LanguageButton from '../buttons/languageButton'

import { inject, observer } from "mobx-react";

// Translations
import _useTranslate from '../hooks/_useTranslate';

const CookiesModal = ({ navigation, feathersStore }) => {

  let footer = _useTranslate(feathersStore.language, "footer");

  const redColored = {color: "hsl(358, 78%, 50%)", fontSize: 35, marginRight: 1};

  let navigate = useNavigate();

  useEffect(() => {
    if(feathersStore.showCookies){
      const showCookies = localStorage.getItem('show_cookies');
      showCookies === "false" && feathersStore.setShowCookies(false);      
    }    
  }, [feathersStore.showCookies])

  const okCookies = () => {
    feathersStore.setShowCookies(false)
    localStorage.setItem('show_cookies', 'false');    
  }

  const goToPrivacyPolicy = () => {
    feathersStore.setShowCookies(false);
    navigate("/privacypolicy")
  } 

  return (
    <div className="cookie-alert-container"> 
      <CSSTransition
        in={feathersStore.showCookies}
        timeout={300}
        classNames="my-alert"
        unmountOnExit
      > 
        <div className="cookie-alert">      
          <div className="alert-title-text">
            <CookieIcon sx={redColored}/>
            {footer.cookiesManagement}
          </div>  
          <div className="cookie-body-container">
            <div className="cookie-body-text">
              {footer.cookiesText}
            </div>    
            <div className="cookie-buttons-container">       
              <div className="cookie-buttons">             
                <button className="cookie-button" onClick={okCookies} color="secondary">
                  {footer.cookiesAccept}
                </button> 
                <button onClick={goToPrivacyPolicy} className="cookie-button cookie-privacy-button">              
                  {footer.cookiesManage}
                </button>              
              </div>
            </div>
          </div> 
          <div className="cookie-language-button">
            <LanguageButton showCaption={false}/>
          </div>         
        </div>   
      </CSSTransition>
    </div>
  );
}

export default inject('feathersStore')(observer(CookiesModal));
